import styled, { css } from "styled-components";
import { Text, Heading, List, ButtonSettings } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const SettingsPageStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs}%;
  padding-top: 3%;
`;

export const TextDisclaimerStyled = styled(Text)`
  letter-spacing: 0rem;
`;

export const BlockStyled = styled.div`
  & {
    width: 36%;
  }
  & + & {
    width: 57%;
    text-align: center;
  }
`;

export const ContentStyled = styled.div`
  position: relative;
  height: 100%;
`;

export const HeadingStyled = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.small};
`;

export const SettingsHeading = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.medium};
  margin-top: 0;
  text-transform: capitalize;
`;

export const ListInfoStyled = styled(List)`
  position: absolute;
  bottom: ${props => props.theme.baseLayoutPaddingBs * 2}%;
`;

export const LogoStyled = styled.div`
  ${props => `text-align: ${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}`};
`;

export const LogoImg = styled.img`
  width: 14.84vw;
  height: 2.1vw;
`;

export const ListStyled = styled.div`
  width: 98%;
  text-align: start;
  padding: 0.5rem 1rem 1rem 1rem;
  height: 6.5rem;
  margin: 0rem 0rem 1rem;
  p {
    margin-bottom: 0rem;
    line-height: 2.5rem;
  }
  p:first-child {
    color: ${props => props.theme.color.grey};
  }
  .keyHeading {
    line-height: 2.25rem;
  }
  border-radius: 0.5rem;
  background-color: ${props => props.theme.color.secondary};
`;

const wrapperStyles = {
  wrapperStyles: css`
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    > * {
      margin-bottom: 0.8rem;
    }
  `
};

export const ProfileWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 100%;
`;

export const LanguageWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 50%;
`;

export const LogoutWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 50%;
`;

export const DevicesWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 100%;
`;

export const HistoryListWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 100%;

  .heading {
    margin-bottom: 0.6rem;
    // font-size: 2rem;
  }
`;

export const StepText = styled(Text)`
  vertical-align: middle;
  font-weight: normal;
  display: inline-block;
  // margin-bottom: 0rem;
  font-size: 1.75rem;
`;

export const ParentalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  > * {
    margin-bottom: 0.5rem;
  }

  .restricted {
    line-height: 1.2;
  }
`;

export const LineSeparator = styled.div`
  position: absolute;
  border-right: 2px solid ${props => props.theme.color.greyLight};
  top: 18vh;
  ${props => `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"}: 39rem`};
  height: 70vh;
  opacity: 0.2;
`;

export const Spacer = styled.div`
  margin-bottom: ${props => (props.mb ? `${props.mb}rem` : "2rem")};
`;

export const AccountStatusWrapper = styled.div`
  /* padding-top: 8rem; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const HistoryWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 78%;

  ul {
    width: 72%;
    margin: 0 auto;
  }
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  display: block;
  margin-top: ${props => props.theme.spacing.xsmall};
  width: 20%;
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: auto;
`;
